import { ChangeEventHandler, FocusEventHandler } from 'react'
import { styled } from '@mui/material/styles';
import TextField, { TextFieldProps } from '@mui/material/TextField';;

type InputProps = {
    error: boolean;
    height: number;
    width: number;
    about?: string;
    label?: string;
    multiline?: boolean;
}

const StyledTextField = styled(TextField)<InputProps>(({error, height, width, about, label, multiline}) => ({
    borderColor: error ? '#d32f2f' : '#c1c5c8',
    borderRadius: 0,
    borderStyle: 'solid',
    borderWidth: multiline ? '0.1rem' : '0 0 0.1rem 0',
    height: `${height}rem`,
    width: `${width}%`,
    marginTop: '8px',

    '& label': {
        color: '#737373',
        fontSize: '1.6rem',
        fontWeight: 400,
        marginTop: '-0.5rem',
        paddingLeft: multiline ? '0.8rem' : 0,
        textAlign: 'initial', 
        whiteSpace: multiline ? 'break-spaces' : 'normal',
    },

    '& label.Mui-focused': {
        color: '#737373',
        fontSize: '1.6rem',
        marginTop: '0.5rem',
    },

    '& label.Mui-focused.Mui-error': {
        color: '#d32f2f'
    },

    '& .MuiFormHelperText-root': {
        fontSize: '1.2rem',
        lineHeight: '1.3rem',
        marginTop: multiline && label ? '-0.9rem' : 'auto',
        paddingTop: multiline && !label ? 0 : '0.8rem'
    },

    '& .MuiFormLabel-filled': {
        fontSize: '1.6rem',
        marginTop:'0.5rem'
    },
    
    '& .MuiInputBase-input': {
        fontSize: '1.6rem',
        fontWeight: 600,
        paddingLeft: multiline ? '0.8rem' : about ? '2.6rem': 0,
        paddingTop: multiline ? '0.8rem' : 'auto'
    },

    '& .MuiInputBase-inputMultiline': {
        height: '10.2rem !important',
        lineHeight: "1.4"
    },

    '& .MuiInputBase-root.MuiInput-root.Mui-focused': {
        marginTop: multiline && !label && '1.2rem',
    }
    
}));

interface Props {
    label: string;
    width: number;
    about?: string;
    error?: boolean;
    disabled?: boolean;
    fixedText?: boolean;
    height?: number;
    helperText?: string;
    maxLength?: number;
    multiLine?: boolean;
    parentField?: TextFieldProps;
    value?: string;
    onBlur?: FocusEventHandler<HTMLTextAreaElement | HTMLInputElement>,
    onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onFocus?: FocusEventHandler<HTMLTextAreaElement | HTMLInputElement>;
}

const AppText = ({label, width, about, disabled, error, height, helperText, maxLength, multiLine, parentField, value,  onBlur, onChange, onFocus}: Props) => {
    
    const InputProps = parentField ? {...parentField.InputProps, disableUnderline: true} : {disableUnderline: true};
    const inputProps = parentField ? {...parentField.inputProps} : maxLength ? {maxLength: maxLength} : {};
    const params = parentField ? parentField : {};

    return (
        <StyledTextField
            {...params} 
            about={about && about}
            autoComplete="off"
            disabled={disabled}
            height={height ? height : 5}
            error={error ? true : false}
            helperText={helperText && helperText}
            InputProps={InputProps}
            inputProps={inputProps}
            label={label}
            maxRows={7}
            multiline={multiLine}
            onBlur={onBlur && onBlur}
            onChange={onChange && onChange}
            onFocus={onFocus && onFocus}
            value={value && value}
            variant="standard"
            width={width}
        />
    );
};

export default AppText;
